// extracted by mini-css-extract-plugin
module.exports = {"subTitle":"RegularEnrollmentLocationProgramCreateUpdate_subTitle__33hAo","rowSpace":"RegularEnrollmentLocationProgramCreateUpdate_rowSpace__3Es-t"};